import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import PropTypes from 'prop-types';

import { useText } from './Text';


const CustomMultiSelect = ({
  source,
  onCustomMultiSelectChange,
  reset,
  selectSomeItems,
  marginBottom = true,
}) => {
  const selectAllText = useText('selectAll');
  const allItemsAreSelected = useText('allItemsAreSelected');
  const clearSearch = useText('clearSearch');
  const clearSelected = useText('clearSelected');
  const noOptions = useText('noOptions');
  const search = useText('search2');
  const selectAllFiltered = useText('selectAllFiltered');
  const selectSomeItemsText = useText('selectSomeItems');
  const create = useText('create');

  const overrideStrings = {
    allItemsAreSelected: allItemsAreSelected,
    clearSearch: clearSearch,
    clearSelected: clearSelected,
    noOptions: noOptions,
    search: search,
    selectAll: selectAllText,
    selectAllFiltered: selectAllFiltered,
    selectSomeItems: selectSomeItems || selectSomeItemsText,
    create: create,
  };

  const [allAddresses, setAllAddresses] = useState(source || []);
  useEffect(() => {
    setAllAddresses(source);
  }, [source]);

  const [selectedAddresses, setSelectedAddresses] = useState([]);

  const onChange = (selectedList) => {
    setSelectedAddresses(selectedList);
    onCustomMultiSelectChange(selectedList);
  };

  useEffect(() => {
    if (reset) {
      setSelectedAddresses([]);
      onCustomMultiSelectChange([]);
    }
  }, [reset]);

  return (
    <div
      style={{
        height: 36,
        minWidth: marginBottom ? 180 : 210,
        zIndex: 9,
        marginBottom: marginBottom ? 25 : 0,
      }}
    >
      <MultiSelect
        options={allAddresses}
        value={selectedAddresses}
        onChange={onChange}
        labelledBy={selectSomeItems || 'Seçiniz'}
        overrideStrings={overrideStrings}
      />
    </div>
  );
};

CustomMultiSelect.propTypes = {
  source: PropTypes.array.isRequired,
  onCustomMultiSelectChange: PropTypes.func.isRequired,
  reset: PropTypes.bool.isRequired,
  selectSomeItems: PropTypes.string,
  marginBottom: PropTypes.bool,
};
export default CustomMultiSelect;
